import { ThemeStyle, ClassGroupType, Style } from "../../Style.types";

export interface IChipClassGroup {
  chip: ThemeStyle;
  chipPrimary: ThemeStyle;
  chipSecondary: ThemeStyle;
  chipNeutralLighter: ThemeStyle;
  chipNeutralDarker: ThemeStyle;
  chipSuccess: ThemeStyle;
  chipWarning: ThemeStyle;
  chipDanger: ThemeStyle;
  chipInfo: ThemeStyle;
  chipOutlinePrimary: ThemeStyle;
  chipOutlineSecondary: ThemeStyle;
  chipOutlineNeutralLighter: ThemeStyle;
  chipOutlineNeutralDarker: ThemeStyle;
  chipOutlineSuccess: ThemeStyle;
  chipOutlineWarning: ThemeStyle;
  chipOutlineDanger: ThemeStyle;
  chipOutlineInfo: ThemeStyle;
  chipTextPrimary: ThemeStyle;
  chipTextSecondary: ThemeStyle;
  chipTextNeutralLighter: ThemeStyle;
  chipTextNeutralDarker: ThemeStyle;
  chipTextSuccess: ThemeStyle;
  chipTextWarning: ThemeStyle;
  chipTextDanger: ThemeStyle;
  chipTextInfo: ThemeStyle;
  chipXSmall: ThemeStyle;
  chipSmall: ThemeStyle;
  chipMedium: ThemeStyle;
  chipLarge: ThemeStyle;
  chipDisabled: ThemeStyle;
  chipOutlineDisabled: ThemeStyle;
  chipTextDisabled: ThemeStyle;
  chipBlock: Style;
}

export const ChipClassGroup: ClassGroupType<IChipClassGroup> = {
  chip: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-start",
    alignItems: "center",
    position: "relative",
    gap: theme.fonts.baseSize * 0.5,
    borderRadius: 16,
  }),
  chipBlock: {
    alignSelf: "stretch",
    justifyContent: "center",
  },
  chipPrimary: (theme) => ({
    backgroundColor: theme.colors.primary.main,
    color: theme.colors.primary.contrast,
  }),
  chipSecondary: (theme) => ({
    backgroundColor: theme.colors.secondary.main,
    color: theme.colors.secondary.contrast,
  }),
  chipNeutralLighter: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.contrast,
  }),
  chipNeutralDarker: (theme) => ({
    backgroundColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.contrast,
  }),
  chipSuccess: (theme) => ({
    backgroundColor: theme.colors.success.main,
    color: theme.colors.success.contrast,
  }),
  chipWarning: (theme) => ({
    backgroundColor: theme.colors.warning.main,
    color: theme.colors.warning.contrast,
  }),
  chipDanger: (theme) => ({
    backgroundColor: theme.colors.danger.main,
    color: theme.colors.danger.contrast,
  }),
  chipInfo: (theme) => ({
    backgroundColor: theme.colors.info.main,
    color: theme.colors.info.contrast,
  }),
  chipTextPrimary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.primary.main,
  }),
  chipTextSecondary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.secondary.main,
  }),
  chipTextNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralLighter.main,
  }),
  chipTextNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.main,
  }),
  chipTextSuccess: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.success.main,
  }),
  chipTextWarning: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.warning.main,
  }),
  chipTextDanger: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.danger.main,
  }),
  chipTextInfo: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.info.main,
  }),
  chipDisabled: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralDarker.light,
  }),
  chipOutlineDisabled: (theme) => ({
    backgroundColor: "transparent",
    borderColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralLighter.dark,
  }),
  chipTextDisabled: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.light,
  }),
  chipXSmall: (theme) => ({
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize * 0.875,
  }),

  chipSmall: (theme) => ({
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize,
  }),
  chipMedium: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize,
  }),
  chipLarge: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize * 1.125,
  }),
  chipOutlinePrimary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.primary.main,
    color: theme.colors.primary.main,
  }),
  chipOutlineSecondary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.secondary.main,
    color: theme.colors.secondary.main,
  }),
  chipOutlineNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.main,
  }),
  chipOutlineNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.main,
  }),
  chipOutlineSuccess: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.success.main,
    color: theme.colors.success.main,
  }),
  chipOutlineWarning: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.warning.main,
    color: theme.colors.warning.main,
  }),
  chipOutlineDanger: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.danger.main,
    color: theme.colors.danger.main,
  }),
  chipOutlineInfo: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.info.main,
    color: theme.colors.info.main,
  }),
};
